import { render } from "./accountOrders.vue?vue&type=template&id=30dcaa8a"
import script from "./accountOrders.vue?vue&type=script&lang=js"
export * from "./accountOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__